import { useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components/macro';
import { countryDescriptionByCode } from '../constants/countryCodes';
import { useAddressSelectStore } from '../models/AddressSelect';
import { AddressSelectFormProps } from '../types/AddressSelectProps';

const UnstyledAddressSelectForm: React.FC<AddressSelectFormProps> = (props) => {
  const state = useAddressSelectStore();

  return useObserver(() => (
    <span className={'ww-address-select-edit-form ' + (props.className || '')}>
      {state.hasCountrySelect && (
        <>
          <label
            className="ww-address-select-country-label"
            htmlFor="ww-address-select-country"
          >
            Country
          </label>
          <select
            className="ww-address-select-country"
            id="ww-address-select-country"
            value={state.country}
            onChange={state.onCountryChange}
          >
            {state.availableCountries?.map((c) => (
              <option value={c} key={c}>
                {countryDescriptionByCode.get(c)}
              </option>
            ))}
          </select>
        </>
      )}
      {state.hasStateSelect && (
        <>
          <label
            className="ww-address-select-state-label"
            htmlFor="ww-address-select-state"
          >
            State
          </label>
          <select
            className="ww-address-select-state"
            id="ww-address-select-state"
            value={state.state}
            onChange={state.onStateChange}
          >
            <option value="">Select your State</option>
            {state.availableStates?.list?.map((s) => (
              <option value={s.description} key={s.id}>
                {s.description}
              </option>
            ))}
          </select>
        </>
      )}
      {state.hasPostcodeEntry && (
        <>
          <label
            className="ww-address-select-postcode-label"
            htmlFor="ww-address-select-postcode"
          >
            {['US', 'PH'].indexOf(state.country) >= 0 ? 'Zip' : 'Postcode'}
          </label>
          <input
            type="text"
            value={state.postcode}
            className="ww-address-select-postcode"
            id="ww-address-select-postcode"
            onChange={state.onPostcodeChange}
            placeholder={
              ['US', 'PH'].indexOf(state.country) >= 0 ? 'Zip' : 'Postcode'
            }
          />
        </>
      )}
    </span>
  ));
};

const AddressSelectForm = styled(UnstyledAddressSelectForm)`
  &.ww-address-select-edit-form {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
  }
  &.ww-address-select-edit-form > *,
  &.ww-address-select-edit-form > label,
  &.ww-address-select-edit-form > input[type='text'] {
    flex: 1 1 content;
    margin-bottom: 10px;
    padding: 5px;
  }

  &.ww-address-select-edit-form > label {
    padding: 0;
    margin-bottom: 5px;
  }

  label {
    font-size: 1em;
  }
`;

export default AddressSelectForm;
